import { render, staticRenderFns } from "./ListCustomerDns.vue?vue&type=template&id=069a3c64&"
import script from "./ListCustomerDns.vue?vue&type=script&lang=js&"
export * from "./ListCustomerDns.vue?vue&type=script&lang=js&"
import style0 from "./ListCustomerDns.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports